import React from 'react';
import { FadeIn } from './FadeIn';
import { X } from 'lucide-react';
export function WhyItFailed() {
  const reasons = ['Intentaste razonar con lógica cuando el cerebro de tu hijo aún no tiene desarrollada la zona del razonamiento.', 'Aplicaste "métodos de adiestramiento" que solo silencian el síntoma pero rompen la conexión emocional.', 'Buscaste soluciones externas sin entender que la calma de tu hijo depende directamente de la regulación de tu propio sistema nervioso.', 'Ignoraste los ciclos biológicos (Saltos de Desarrollo) que dictan el comportamiento según la edad.'];
  return <section className="py-20 bg-white" data-id="element-193">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-194">
        <FadeIn data-id="element-195">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brown mb-16" data-id="element-196">
            ¿Por qué nada ha funcionado hasta ahora?
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-197">
          {reasons.map((reason, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-198">
              <div className="flex items-start gap-4 p-6 rounded-2xl bg-cream/50 border border-cream-dark transition-colors hover:bg-cream" data-id="element-199">
                <div className="flex-shrink-0 mt-1" data-id="element-200">
                  <div className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center" data-id="element-201">
                    <X className="w-5 h-5 text-red-400" data-id="element-202" />
                  </div>
                </div>
                <p className="text-lg text-brown-light leading-relaxed" data-id="element-203">
                  {reason}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}